import { authClient } from '@/lib/auth-client';

/**
 * User Service
 *
 * Handles all user profile-related business logic and operations.
 * Provides a centralized interface for user management.
 */
export const userService = {
  /**
   * Update user profile information
   */
  async updateProfile(name: string): Promise<any> {
    const response = await authClient.updateUser({
      name,
    });
    if (response?.error) {
      throw new Error(response.error.message || 'Failed to update profile');
    }
    return response.data;
  },

  /**
   * Change user password
   */
  async changePassword(currentPassword: string, newPassword: string): Promise<any> {
    const response = await authClient.changePassword({
      newPassword,
      currentPassword,
    });
    if (response?.error) {
      throw new Error(response.error.message || 'Failed to change password');
    }
    return response.data;
  },
};
